// extracted by mini-css-extract-plugin
module.exports = {"container":"N80-kb","bold":"RqL4sE","regular":"c7sFMp_","unstyledLink":"QArHws"};